import * as React from "react";
import { Account, TradingAccount } from "swan-public-api-client";
import { WrappedComponentProps, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { AppState } from "../Store/RootReducer";
import { Card, Layout, Divider } from "antd";
import { saveActiveTradingAccount } from "../Platform/State";
import Title from "antd/lib/typography/Title";
import { AccountSelectorTradingAccountList } from "./AccountSelectorTradingAccountList";
import { AccountSelectorClientAccountDescription } from "./AccountSelectorClientAccountDescription";
import "./AccountSelector.less";

interface PropsFromState {
  clientAccount: Account;
  tradingAccounts: TradingAccount[];
  linkedTradingAccounts: TradingAccount[];
}

interface PropsFromActions {
  setActiveTradingAccountAction: typeof saveActiveTradingAccount;
}

interface Props extends WrappedComponentProps, PropsFromState, PropsFromActions {}

class AccountSelectorCmp extends React.PureComponent<Props> {
  public render() {
    const linkedTradingAccountsByClientAccount = this.getLinkedTradingAccountsByClientAccount();

    return (
      <Layout className="platform-layout account-selector">
        <Layout className="single-column-layout">
          <Title className="platform-title" level={2}>{this.props.intl.formatMessage({ id: "accountSelector.title" })}</Title>
          <Card
            className="platform-card"
            bordered={false}
            title={this.props.clientAccount.AccountCode}>
            <AccountSelectorClientAccountDescription />
            <Divider />
            <AccountSelectorTradingAccountList
              tradingAccounts={this.props.tradingAccounts}
              onTradingAccountSelected={tradingAccount => this.onTradingAccountSelected(tradingAccount)}
              bordered={false}
            />
          </Card>
          {linkedTradingAccountsByClientAccount.map(x => {
            return (
              <Card
                className="platform-card"
                bordered={false}
              >
                <AccountSelectorTradingAccountList
                  tradingAccounts={x}
                  onTradingAccountSelected={tradingAccount => this.onTradingAccountSelected(tradingAccount)}
                  bordered={false}
                />
              </Card>
            );
          })}
        </Layout>
      </Layout>
    );
  }

  private onTradingAccountSelected(tradingAccount: TradingAccount) {
    this.props.setActiveTradingAccountAction(tradingAccount);
  }

  private getLinkedTradingAccountsByClientAccount() {
    const clientAccountsForLinkedTradingAccounts = new Set<string>(this.props.linkedTradingAccounts.map(x => x.AccountKey));
    const linkedTradingAccountsByClientAccount = new Map<string, TradingAccount[]>(Array.from(clientAccountsForLinkedTradingAccounts).map(x => [x, []]));
    this.props.linkedTradingAccounts.forEach(x => {
      const byClientAccount = linkedTradingAccountsByClientAccount.get(x.AccountKey)!;
      byClientAccount.push(x);
    });

    return Array.from(linkedTradingAccountsByClientAccount.values());
  }
}

const AccountSelectorWithIntl = injectIntl(AccountSelectorCmp);

const mapStateToProps = (state: AppState): PropsFromState => ({
  clientAccount: state.clientAccount.account!,
  tradingAccounts: state.tradingAccounts,
  linkedTradingAccounts: state.linkedTradingAccounts
});

const mapDispatchToProps = (dispatch: any): PropsFromActions => ({
  setActiveTradingAccountAction: (tradingAccount: TradingAccount | undefined) => dispatch(saveActiveTradingAccount(tradingAccount))
});

export const AccountSelector = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  AccountSelectorWithIntl
);
